module.exports = __webpack_public_path__ + "media/images/850/CBD_facts_woman_on_bed-42ff49a06dc9c514979c84bc5ee978a3.jpg";